import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSync } from '@fortawesome/pro-light-svg-icons'

import { Button } from '@domain-group/suit-theme'

interface ReplaceImageProps {
  loading: boolean,
  onClick: () => void,
}

const ReplaceImage = (props: ReplaceImageProps) => {
  const { loading, onClick } = props

  return (
    <Button
      buttonStyle="secondaryUtility"
      icon={<FontAwesomeIcon icon={faSync} />}
      loading={loading}
      //@ts-expect-error
      marginTop="medium"
      onClick={() => onClick()}
      size="medium"
    >
      Replace Image
    </Button>
  )
}

export default ReplaceImage
